import React, { useState } from "react";
import { FaSearch, FaFacebook, FaLinkedin, FaBars, FaTimes } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../assets/images/logo2.png";
import { MdEmail, MdPhone } from "react-icons/md";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMouseEnter = (menu) => {
    setOpenMenu(menu);
  };

  const handleMouseLeave = () => {
    setOpenMenu(null);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const menuItems = [
    { name: "Inicio", path: "/" },
    { name: "Nosotros", path: "/nosotros" },
    { name: "Servicios", subItems: ["Capacitaciones", "Certificaciones", "Otros Servicios"] },
    { name: "Contacto", subItems: ["Perú", "México"] },
  ];

  return (
    <nav className="bg-azul-oscuro fixed top-0 left-0 w-full z-50 shadow-lg">
      {/* Barra superior con contacto */}
      <div className="bg-azul w-full flex items-center justify-between px-4 md:px-36 py-2">
        <a
          className="flex items-center text-blanco hover:text-celeste transition duration-200 text-sm md:text-base"
          href="/perú"
        >
          <MdEmail className="mr-2" />
          informes@cecompperu.com / ventas@cecompperu.com
        </a>

        <a
          href="https://wa.me/51959118503"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center text-blanco hover:text-celeste transition duration-300 text-sm md:text-base"
        >
          <MdPhone className="mr-2" />
          +51 (76) 609440 / 959118503
        </a>
      </div>

      {/* Contenedor principal del Navbar */}
      <div className="container mx-auto flex justify-between items-center py-2 px-4 md:px-0">
        {/* Logo */}
        <NavLink to="/" className="flex items-center">
          <img src={logo} alt="Logo" className="h-12 md:h-16" />
        </NavLink>

        {/* Menú principal (desktop) */}
        <ul className="hidden md:flex space-x-6 relative">
          {menuItems.map((item) => (
            <li
              key={item.name}
              className="relative"
              onMouseEnter={() => handleMouseEnter(item.name)}
              onMouseLeave={handleMouseLeave}
            >
              {item.subItems ? (
                <span className="px-4 py-2 rounded-lg text-blanco hover:bg-oro hover:text-azul-oscuro cursor-pointer">
                  {item.name}
                </span>
              ) : (
                <NavLink
                  to={item.path}
                  className="px-4 py-2 rounded-lg text-blanco hover:bg-oro hover:text-azul-oscuro"
                >
                  {item.name}
                </NavLink>
              )}

              {item.subItems && openMenu === item.name && (
                <ul className="absolute left-0 w-48 bg-blanco text-azul-oscuro shadow-lg rounded-lg mt-1 text-center">
                  {item.subItems.map((subItem) => (
                    <li key={subItem} className="border-b last:border-none">
                      <NavLink
                        to={`/${subItem.toLowerCase().replace(/ /g, "-")}`}
                        className="block px-4 py-2 hover:bg-oro hover:text-blanco"
                        onClick={() => setTimeout(() => setOpenMenu(null), 150)}
                      >
                        {subItem}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>

        {/* Buscador y redes sociales (desktop) */}
        <div className="hidden md:flex items-center">
          <input
            type="text"
            placeholder="Buscar..."
            className="px-4 py-2 rounded-lg focus:outline-none"
          />
          <button className="bg-oro text-azul-oscuro px-4 py-2 ml-4 rounded-lg hover:bg-opacity-90 transition duration-300">
            <FaSearch />
          </button>
          <a
            href="https://www.facebook.com/cecompperu.training/"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-4 text-blanco hover:text-oro"
          >
            <FaFacebook className="w-6 h-6" />
          </a>
          <a
            href="https://www.linkedin.com/in/cecomp-peru-42473014a/"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-4 text-blanco hover:text-oro"
          >
            <FaLinkedin className="w-6 h-6" />
          </a>
        </div>

        {/* Menú hamburguesa (mobile) */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMobileMenu} className="text-blanco text-2xl">
            {mobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* Menú móvil */}
      <div
        className={`md:hidden fixed top-20 left-0 w-full bg-azul-oscuro shadow-lg transform transition-transform duration-300 ${
          mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <ul className="flex flex-col space-y-4 p-4">
          {menuItems.map((item) => (
            <li key={item.name}>
              {item.subItems ? (
                <div className="text-blanco">
                  <span className="block px-4 py-2">{item.name}</span>
                  <ul className="pl-4">
                    {item.subItems.map((subItem) => (
                      <li key={subItem}>
                        <NavLink
                          to={`/${subItem.toLowerCase().replace(/ /g, "-")}`}
                          className="block px-4 py-2 text-blanco hover:bg-oro hover:text-azul-oscuro rounded-lg"
                          onClick={toggleMobileMenu}
                        >
                          {subItem}
                        </NavLink>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <NavLink
                  to={item.path}
                  className="block px-4 py-2 text-blanco hover:bg-oro hover:text-azul-oscuro rounded-lg"
                  onClick={toggleMobileMenu}
                >
                  {item.name}
                </NavLink>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;